export default class AssessmentSaveModel {
    work_orders_id: number;
    issue_description: string | null;
    root_cause: string | null;
    attachment: Array<{
        path: number | string | null;
        label: string | null;
    }>;

    constructor(data: any = {}) {
        this.work_orders_id = data.work_orders_id || null;
        this.issue_description = data.issue_description || null;
        this.root_cause = data.root_cause || null;
        this.attachment = data.attachment || [];
    }
}
